const TERMS_BUTTON_TYPE = {
    CHECKBOX: 'checkbox',
    LINK: 'link',
};

const HOTEL_SELECTION_SOURCE = {
    MAP: 'map',
};

const HOTEL_VIEW_TRIGGER = {
    RECHECK: 'recheck',
};

const PAGE_PROCESS = {
    HOTEL_RESERVATION: 'hotel_reservation',
    MY_HOTELS: 'my_hotels',
    SEARCH: 'search',
    LOGIN: 'login',
};

const ERROR_TYPE = {
    VALIDATION: 'validation',
    SYSTEM: 'system',
};

const FUNNEL_STEP = {
    SEARCH_HOTEL: 'search_hotel',
    HOTEL_LIST: 'hotel_list',
    SELECT_HOTEL: 'select_hotel',
    VIEW_HOTEL: 'view_hotel',
    ROOM_SELECT: 'room_select',
    PAYMENT: 'payment',
    CONFIRMATION: 'confirmation',
};

// Same names as the mobile contact form fields, so both apps send identical invalid_<field> codes.
const VALIDATED_FIELD = {
    FIRST_NAME: 'first_name',
    LAST_NAME: 'last_name',
    EMAIL: 'email',
    TEL: 'tel',
    FREQUENT_FLYER_NUMBER: 'frequent_flyer_number',
    COUPON: 'coupon',
};

const SYSTEM_ERROR_TEXT = {
    COUPON_VALIDATION_FAILED: 'coupon_validation_failed',
};

const BOOKING_PANEL_COMPONENT = {
    SHOW_INVOICE: 'show_invoice',
    SHOW_VOUCHER: 'show_voucher',
    SEND_BOOKING_CONFIRMATION: 'send_booking_confirmation',
    CANCEL_BOOKING: 'cancel_booking',
    COPY_RESERVATION_ID: 'copy_reservation_id',
    COPY_PAYMENT_ID: 'copy_payment_id',
    REDEEM_POINTS: 'redeem_points',
    SETTLE_PAYMENT: 'settle_payment',
};

const POPUP_NAME = {
    CANCEL_BOOKING: 'cancel_booking',
    TERMS_CONDITIONS: 'terms_conditions',
};

const POPUP_CHOICE = {
    CONFIRM: 'confirm',
    CANCEL: 'cancel',
    CLOSE: 'close',
    MORE_INFO: 'more_info',
};

module.exports = {
    TERMS_BUTTON_TYPE,
    HOTEL_SELECTION_SOURCE,
    HOTEL_VIEW_TRIGGER,
    PAGE_PROCESS,
    ERROR_TYPE,
    FUNNEL_STEP,
    VALIDATED_FIELD,
    SYSTEM_ERROR_TEXT,
    BOOKING_PANEL_COMPONENT,
    POPUP_NAME,
    POPUP_CHOICE,
};
